var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddHexagon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9597_41662)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.0345 8.94727L10.3678 12.6139L8.70117 10.9473",
    stroke: "#0F1A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.6596 1.78844C10.8453 1.68126 11.074 1.68126 11.2596 1.78844L18.5982 6.02536C18.7838 6.13254 18.8982 6.33062 18.8982 6.54498V15.0188C18.8982 15.2332 18.7838 15.4313 18.5982 15.5384L11.2596 19.7754C11.074 19.8825 10.8453 19.8825 10.6596 19.7754L3.32107 15.5384C3.13543 15.4313 3.02107 15.2332 3.02107 15.0188V6.54498C3.02107 6.33062 3.13543 6.13254 3.32107 6.02536L10.6596 1.78844Z",
    stroke: "#0F1A24",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9597_41662"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.958984 0.78125)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddHexagon);
export default __webpack_public_path__ + "static/media/add-hexagon.48db2ee0dd34ad36c2ca84ff14532d6f.svg";
export { ForwardRef as ReactComponent };